var _ellipse, _ellipse2, _ellipse3, _ellipse4, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.6045,
    cy: 54.6854,
    rx: 20.6045,
    ry: 21.0187,
    fill: "#DCE4FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.1951,
    cy: 12.4403,
    rx: 12.1951,
    ry: 12.4403,
    transform: "matrix(-1 0 0 1 76.5664 51.5717)",
    fill: "#DCE4FF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.48508,
    cy: 9.67576,
    rx: 9.48508,
    ry: 9.67576,
    transform: "matrix(-1 0 0 1 46.7559 4.35339)",
    fill: "#DCE4FF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.21456,
    cy: 4.29929,
    rx: 4.21456,
    ry: 4.29929,
    transform: "matrix(-1 0 0 1 60.7305 0)",
    fill: "#DCE4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4637 55.6695C36.8557 56.9123 38.2155 58.1231 39.5748 59.3367C40.5042 60.1684 41.4299 61.0053 42.3668 61.8265C42.5708 62.0054 42.6202 62.1784 42.5653 62.4423C41.5614 67.1902 41.1538 69.9276 40.1584 74.677C40.1091 74.9066 40.0819 75.1429 40.0948 75.3979C40.281 74.9301 40.4724 74.4661 40.6558 73.9979C42.682 68.8662 44.1147 65.7455 46.1539 60.6219C46.2915 60.2751 46.2267 60.0907 45.9765 59.8598C44.2578 58.2733 42.5498 56.6739 40.8381 55.0798C40.7256 54.9753 40.6168 54.8656 40.4829 54.734C41.3586 53.4525 42.2255 52.1899 43.0901 50.9241C45.5201 47.3689 47.945 43.8098 50.3853 40.2623C50.5971 39.9546 50.572 39.774 50.3307 39.5065C49.3394 38.4027 48.3751 37.2742 47.3847 36.1647C47.1976 35.9534 47.1729 35.8052 47.3095 35.5523C49.8744 30.8241 52.4291 26.0883 54.9968 21.3605C55.087 21.1967 55.2567 21.0405 55.4249 20.9635C58.6685 19.4897 62.0522 18.8832 65.5957 19.2856C67.6489 19.5187 69.6651 19.9071 71.5399 20.8414C74.9513 22.5407 77.389 25.2404 79.0752 28.6581C81.4078 33.3851 81.8186 38.307 80.4081 43.4087C78.9676 48.6228 76.2357 53.0698 72.7282 57.064C68.9978 61.311 64.6448 64.8052 59.9581 67.8751C53.5988 72.0435 46.8441 75.3921 39.7424 78.029C39.4111 78.1517 39.1879 78.1253 38.9087 77.8954C33.7568 73.6538 29.0527 68.9478 24.7927 63.7829C21.9505 60.3353 19.3663 56.7026 17.1798 52.7881C14.942 48.7825 13.1588 44.5871 12.1904 40.0607C11.3552 36.1448 11.0628 32.1864 11.9717 28.2804C13.6401 21.098 17.8097 16.0885 24.7819 13.7321C26.9077 13.0137 29.1016 13.0387 31.3005 13.3672C35.6562 14.017 39.437 15.8528 42.6026 18.9971C42.9447 19.3347 42.9903 19.6011 42.8237 20.0546C41.1053 24.6981 39.4162 29.3555 37.7033 34C37.5676 34.3706 37.6254 34.5803 37.9087 34.8373C39.824 36.5779 41.7145 38.3466 43.6298 40.0872C43.908 40.3404 43.9172 40.5124 43.7414 40.8292C41.0732 45.5897 38.4181 50.3584 35.7607 55.1237C35.6704 55.2875 35.583 55.4518 35.467 55.6671L35.4637 55.6695Z",
    fill: "#3658C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6974 74.796C-16.3726 27.0022 23.9249 2.56193 39.1121 19.0656C39.3524 19.3267 39.4267 19.7059 39.3111 20.0414L34.7137 33.3801C34.5839 33.7565 34.6899 34.174 34.9834 34.4431L39.9286 38.9762C40.2649 39.2845 40.3499 39.7814 40.1352 40.184L32.8774 53.7923C32.6569 54.2058 32.7531 54.717 33.1089 55.0221L39.0406 60.108C39.3218 60.3492 39.4467 60.726 39.3651 61.0874L36.3775 74.3184C36.2083 75.0675 35.2581 75.3207 34.6974 74.796Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71 52.5C60.672 65.6448 49.9032 70.4148 39.1091 75.0874C38.3073 75.4345 37.4753 74.6588 37.766 73.8349L42.8012 59.5634C42.9237 59.2164 42.8457 58.8302 42.5982 58.558L38.5297 54.0826C38.2189 53.7408 38.1828 53.2307 38.4421 52.8484L47.0918 40.1016C47.3352 39.7429 47.3198 39.2683 47.0537 38.9261L44.4112 35.5287C44.1624 35.2088 44.1313 34.7704 44.3324 34.4185L51.8025 21.3491C51.9305 21.1252 52.1497 20.9559 52.3978 20.8856C75.5429 14.3205 82.4351 36.5903 71 52.5Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBroken);
export default __webpack_public_path__ + "static/media/heart-broken.4bd3522bff1356b831f78709894e4156.svg";
export { ForwardRef as ReactComponent };